import script from "./DayTimeSelectorDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./DayTimeSelectorDesktop.vue?vue&type=script&setup=true&lang=js"

import "./DayTimeSelectorDesktop.vue?vue&type=style&index=0&id=18c22584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c22584"]])

export default __exports__